module.exports = __webpack_public_path__ + "static/img/250529TW.2a90e2c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/250529TW.jpg
// module id = iI+0
// module chunks = 1